const LiveFiltersMock = [
  {
    title: 'EXTERIORES',
    filter: 'exteriores',
    active: true,
  },
  {
    title: 'PISO PILOTO',
    filter: 'interiores',
    active: false,
  },
];

export default LiveFiltersMock;
